import { LANGUAGE_CODES } from './languageCodes';

const EUROPEAN_DATE_FORMAT = {
    long: 'DD MMM YYYY',
    short: 'DD MMM YYYY',
    longWithTime: 'DD MMM YYYY HH:mm',
    shortWithTime: 'DD MMM YYYY HH:mm',
};

const DATE_FORMAT_EXCEPTIONS = {
    [LANGUAGE_CODES.ENGLISH]: {
        long: 'MMM DD YYYY',
        short: 'DD MMM YYYY',
        longWithTime: 'MMM DD YYYY HH:mm',
        shortWithTime: 'DD MMM YYYY HH:mm',
    },
    [LANGUAGE_CODES.UKRAINIAN]: {
        ...EUROPEAN_DATE_FORMAT,
        short: 'MMM DD YYYY',
    },
};

export const datesFormat = new Proxy(
    {},
    {
        get(target, language) {
            return DATE_FORMAT_EXCEPTIONS[language] || EUROPEAN_DATE_FORMAT;
        },
    }
);
